import { css } from "@compiled/react";

const containerStyle = css({
    zIndex: -1,
    position: "absolute",
    insetBlockStart: 0,
    insetInlineStart: 0,
    width: "100vw",
    height: "100vh"
});

const backgroundBlurStyle = css({
    width: 832,
    height: 232,
    position: "absolute",
    insetInlineStart: "50%",
    transform: "translateX(-50%)",
    insetBlockStart: 276,
    background:
        // eslint-disable-next-line local/ensure-wac-token-usage
        "conic-gradient(from 180deg at 50% 50%, #FCA700 -7.2deg, #FCA700 1.8deg, #82B536 70.2deg, #1868DB 128.85deg, #BF63F3 223.2deg, #F0F1F2 316.8deg, #FCA700 352.8deg, #FCA700 361.8deg)",
    filter: "blur(98px)",
    opacity: 0.4
});

const leftVectorStyle = css({
    position: "absolute",
    insetInlineStart: 0,
    insetBlockStart: 220
});

const leftTicketsStyle = css({
    position: "absolute",
    insetInlineStart: 0,
    insetBlockStart: 149,
    backgroundImage:
        'url("https://dam-cdn.atl.orangelogic.com/public/AT21HYS.webp")',
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: 273,
    height: 167.5,
    zIndex: 2
});

const rightVectorStyle = css({
    position: "absolute",
    insetInlineEnd: 0,
    insetBlockStart: 78
});

const rightGoalsStyle = css({
    position: "absolute",
    insetInlineEnd: 0,
    insetBlockStart: 124,
    backgroundImage:
        'url("https://dam-cdn.atl.orangelogic.com/public/AT21HYR.webp")',
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: 285,
    height: 212.5,
    zIndex: 2
});

export const PaidJiraAiBackground = () => {
    return (
        <div css={containerStyle} data-testid="paid-jira-ai-background">
            <div css={backgroundBlurStyle} />
            <div css={leftVectorStyle}>
                <svg
                    width="278"
                    height="346"
                    viewBox="0 0 278 346"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M126.304 216.886C141.869 233.09 165.768 229.102 199.031 197.151C202.628 193.696 205.438 189.284 209.035 185.829L277.314 256.912C271.899 263.892 263.781 271.69 252.99 282.056C170.191 361.588 93.474 360.919 42.4374 307.786C4.43138 268.22 0.727808 230.217 3.22073 191.465C3.82247 163.224 5.10354 142.958 -8.71683 128.57C-24.2812 112.367 -48.1115 116.288 -81.4433 148.306L-93.0907 159.494L-160.514 89.3015C-154.209 81.4664 -146.09 73.6677 -136.19 64.1579C-52.5348 -16.1976 23.3597 -16.3841 75.219 37.6046C113.258 77.2054 116.038 116.03 114.333 154.025C113.8 182.2 112.45 202.531 126.27 216.919L126.304 216.886Z"
                        fill="#FCA700"
                    />
                </svg>
                <div css={leftTicketsStyle} />
            </div>
            <div css={rightVectorStyle}>
                <svg
                    width="259"
                    height="422"
                    viewBox="0 0 259 422"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M387.189 211.854L214.396 384.134L111.034 351.343L69.1056 110.944L261.572 55.9512L387.189 211.854Z"
                        fill="#BF63F3"
                        stroke="#BF63F3"
                        strokeWidth="6"
                    />
                </svg>
                <div css={rightGoalsStyle} />
            </div>
        </div>
    );
};
